module.exports = __webpack_public_path__ + "static/media/mu.d6db35bc.svg";